/**
 * Safe markdown renderer for published posts (AXAI-SPEC-019 PR-5).
 * Raw HTML in the markdown is dropped (skipHtml), never injected; react-markdown's
 * default URL transform neutralises javascript: and other unsafe link protocols.
 */

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function PostBody({ markdown, className = '' }: { markdown: string; className?: string }) {
  return (
    // Typography comes from the prose plugin (markdown needs a system), but the colours and the
    // link treatment are the brand's: an underlined ink link, like every other link on the site.
    // Until 20 Oct 2026 a post's links were accentPrimary, which is why a post read as a page from
    // a different site.
    <div
      className={`${className} prose prose-slate max-w-none dark:prose-invert prose-headings:text-ink prose-p:text-ink prose-li:text-ink prose-strong:text-ink prose-a:text-ink prose-a:underline prose-a:underline-offset-2`}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        components={{
          a: ({ href, children }) => {
            const external = typeof href === 'string' && /^https?:\/\//i.test(href);
            return (
              <a href={href} {...(external ? { rel: 'noopener noreferrer nofollow' } : {})}>
                {children}
              </a>
            );
          },
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
